import ApiEndpoint from "./ApiEndpoint";
import { AxiosResponse } from "axios";
import { DateTimeString, NumberishId } from "../../../model/type";
import { Offer } from "../../../model/Offer";
import { PatchBodyType } from "../PatchBodyType";

export class Endpoint extends ApiEndpoint {
    public get = (offerId: NumberishId): Promise<AxiosResponse<ApiOffer>> => {
        return this.connection.get('/offers/' + offerId);
    }

    public patch = (offerId: NumberishId, body: PatchBody): Promise<AxiosResponse<any>> => {
        return this.connection.patch('/offers/' + offerId, body);
    }
}

export type ApiOffer = Omit<Offer, 'created' | 'startDate' | 'endDate'> & {
    readonly created: DateTimeString,
    readonly startDate: DateTimeString,
    readonly endDate: DateTimeString,
};

export type PatchBody = PatchBodyType<'UPDATE', {
    readonly logoFileBase64?: string,
    readonly config?: {
        readonly showPrices?: boolean
    }
    readonly consultant?: {
        readonly name?: string,
        readonly phone?: string,
        readonly email?: string,
    }
    readonly name?: string,
}>;